import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaFacebook, FaLinkedinIn, FaInstagram, FaTiktok, FaMailchimp } from 'react-icons/fa';
import Send from '../assets/img/char.jpeg';

const Contact = () => {
  return (
    <div name='contact' className='w-full justify-center items-center'>

      <div className='bg-[#15381b] text-[#c6bab8]'>
        <div className='lg:flex md:flex grid flex-grid lg:gap-28 md:gap-20 gap-4 items-center justify-center pt-10 lg:px-0 md:px-0 px-4'>
          <div className='flex items-center pt-5 lg:pt-0 md:pt-0'>
            <FaMapMarkerAlt className='text-2xl' />
            <a href="https://www.google.com/maps?q=2+Ahmed+Onibudo+Street,+Victoria+Island,+Lagos"  className='ml-2' target="_blank" rel="noopener noreferrer">2, Ahmed Onibudo Street,Victoria Island, Lagos.</a>
          </div>
          <div className='flex items-center mt-5 lg:mt-3'>
            <FaEnvelope className='text-2xl' />
            <a href="mailto:info@adf.ng" className='ml-2'>admin@adf.ng</a>
          </div>
          <div className='flex items-center mt-5 lg:mt-3'>
            <FaPhone className='text-2xl' />
            <a href="tel:+2347031447139" className='ml-2'>+2347031447139</a>
          </div>   
          <div className='flex items-center mt-5 lg:mt-3'>
            <FaClock className='text-2xl' />
            <p className='ml-2'>Monday to Friday - 9:00 am to 4:00 pm</p>
          </div>
        </div>
        <div className="flex items-center justify-center mt-20 pb-12 gap-10">
          <a href="https://www.facebook.com/share/18NoGqHLjq/?mibextid=qi2Omg"
          target="_blank" rel="noopener noreferrer"><FaFacebook className="text-2xl cursor-pointer" /></a>
          <a href="https://www.linkedin.com/company/african-development-foundation-adf" target="_blank"
            rel="noopener noreferrer"><FaLinkedinIn className="text-2xl cursor-pointer" /></a>
          <a href="https://www.instagram.com/adf.ng_" target="_blank"
            rel="noopener noreferrer"><FaInstagram className="text-2xl cursor-pointer" /></a>
          {/* <a href="https://twitter.com/Kuramo_D_Trust"><FontAwesomeIcon icon={faXTwitter} className="text-2xl cursor-pointer" /></a>
          <a href="https://www.tiktok.com/@kuramo_d_trust?_t=8kEsfN1JC45&_r=1"><FaTiktok className="text-2xl cursor-pointer" /></a> */}
        </div>

      </div>
    </div>
  );
};

export default Contact;
